/**
 * Smart Popunders middleware
 *
 * @exports middleware
 */

import { LINKS_SMART_LINKS_PATH } from 'common/selectors/sidebar/affiliates';
import { smartPopunderCloneIterationIdToNewSmartpopSuccessAction } from 'common/reducers/smartPopunders';

/**
 * Smart popunders middleware function
 */
const middleware = () => (next) => (action) => {
  const result = next(action);

  switch (action.type) {
    case smartPopunderCloneIterationIdToNewSmartpopSuccessAction.type: {
      const { payload } = action;

      const clonedSmartpopUrl = `${LINKS_SMART_LINKS_PATH}/${payload.id}`;

      window.open(clonedSmartpopUrl);

      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
